import React from 'react';
import Button from 'react-bootstrap/Button';
import "./Card.css"
import 'tachyons'
function Card(props){
    const githuburl= props.github;
    const siteurl= props.website;
    return(
        <div className='bg-light-green dib br3 pa3 ma2 grow bw2 shadow-5'>
           <img className='imagess' src={props.img} height='200px' width='400px' alt="projects_id" />
           <div className='card__content'>
              <h2 className='Project__name'>{props.name}</h2>
              <p>{props.info}</p> 
             <a href={githuburl}><Button variant="dark" className='btn-github'>GitHub</Button></a>
             <a href={siteurl}><Button variant="primary">View live</Button>{' '}</a>
           </div>
        </div>
    )
}
export default Card;